import { render, staticRenderFns } from "./slidesReport.vue?vue&type=template&id=fddf833c&scoped=true"
import script from "./slidesReport.vue?vue&type=script&lang=js"
export * from "./slidesReport.vue?vue&type=script&lang=js"
import style0 from "./slidesReport.vue?vue&type=style&index=0&id=fddf833c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddf833c",
  null
  
)

export default component.exports